import React from 'react';
import { Box } from '@mui/material';

import LandingNavbar from '../components/LandingNavbar';
import HeroBanner from '../components/HeroBanner';
import ParaQuemSection from '../components/ParaQuemSection';
import ProblemaSection from '../components/ProblemaSection';
import SolucaoSection from '../components/SolucaoSection';
import BeneficiosSection from '../components/BeneficiosSection';
import EconomiaSection from '../components/EconomiaSection';
import ParaClinicasSection from '../components/ParaClinicasSection';
import LeadFormSection from '../components/LeadFormSection';
import FaqSection from '../components/FaqSection';
import CtaFinalSection from '../components/CtaFinalSection';
import Footer from '../components/Footer';

const LandingPage: React.FC = () => {
  return (
    <Box>
      <LandingNavbar />
      <HeroBanner />
      <ParaQuemSection />
      <ProblemaSection />
      <SolucaoSection />
      <BeneficiosSection />
      <EconomiaSection />
      <ParaClinicasSection />
      <LeadFormSection />
      <FaqSection />
      <CtaFinalSection />
      <Footer />
    </Box>
  );
};

export default LandingPage;
